import React from "react";
import { FlatList, StyleSheet } from "react-native";
import { Session } from "@/store/types";
import DrawerSession from "./DrawerSession";
import Text from "./base/Text";
import { layout } from "@/constants";

interface DrawerSessionsListProps {
  sessions: Session[];
  currentSessionId?: string | null;
  onSessionPress: (sessionId: string) => void;
  onSessionDelete?: (sessionId: string) => void;
}

export default function DrawerSessionsList({
  sessions,
  currentSessionId,
  onSessionPress,
  onSessionDelete
}: DrawerSessionsListProps) {
  const renderSession = ({ item }: { item: Session }) => {
    const title = item.title || "New chat";
    return (
      <DrawerSession
        title={title}
        isSelected={item.id === currentSessionId}
        onPress={() => onSessionPress(item.id)}
        onDelete={onSessionDelete ? () => onSessionDelete(item.id) : undefined}
        accessibilityLabel={`Chat session: ${title}`}
      />
    );
  };

  if (sessions.length === 0) {
    return (
      <Text size="small" color="tertiary" style={styles.emptyText}>
        No sessions yet
      </Text>
    );
  }

  return (
    <FlatList
      data={sessions}
      renderItem={renderSession}
      keyExtractor={(item) => item.id}
      style={styles.list}
      showsVerticalScrollIndicator={false}
      nestedScrollEnabled
    />
  );
}

const styles = StyleSheet.create({
  list: {
    flex: 1
  },
  emptyText: {
    textAlign: "center",
    paddingVertical: layout.space.md,
    fontStyle: "italic"
  }
});
